import { render, staticRenderFns } from "./FlexWrapperColV2.vue?vue&type=template&id=593ca38d"
import script from "./FlexWrapperColV2.vue?vue&type=script&lang=js"
export * from "./FlexWrapperColV2.vue?vue&type=script&lang=js"
import style0 from "./FlexWrapperColV2.vue?vue&type=style&index=0&id=593ca38d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports